import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { ComponentProps } from 'react';

export const Loading = () =>
    <Flex center stretch>
        <CircularProgress />
    </Flex>

/**
 * Wrapper around div to simplify flex layouts.
 * Used to get rid of the inline styling in most popular scenarios, not as a comprehensive flex-box layout tool.
 */
export const Flex = ({ row, column, wrap, grow, alignCenter, justifyCenter, className, center, stretch, children, ...props } : {
    /** flex row container */
    row? : boolean
    /** flex column container */
    column? : boolean
    /** flexGrow: 1 */
    grow? : boolean
    /** center the content of the flex container */
    center? : boolean

    wrap? : boolean 
    alignCenter? : boolean
    
    justifyCenter? : boolean

    /** width & height == 100% */
    stretch? : boolean
    className? : string
    children? : any
} & Pick<ComponentProps<'div'>, 'onClick'> ) => {
    const classes = useFlexStyles();
    let classNames = className || '';

    if( row ) classNames += ' ' + classes.row;
    if( column ) classNames += ' ' + classes.column;
    if( grow ) classNames += ' ' + classes.grow;
    if( center ) classNames += ' ' + classes.center;
    if( alignCenter ) classNames += ' ' + classes.alignCenter;
    if( justifyCenter ) classNames += ' ' + classes.justifyCenter;
    if( stretch ) classNames += ' ' + classes.stretch;
    if( wrap ) classNames += ' ' + classes.wrap;

    return <div className={ classNames } {...props }>{ children }</div>
}

const useFlexStyles = makeStyles({
    row : {
        display: "flex",
        flexDirection: "row"
    },

    wrap : {
        flexWrap: "wrap"
    },

    center : {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },

    alignCenter : {
        display: "flex",
        alignItems: "center",
    },

    justifyCenter : {
        display: "flex",
        justifyContent: "center"
    },

    column : {
        display: "flex",
        flexDirection: "column"
    },

    grow : {
        flexGrow: 1
    },

    stretch : {
        height: '100%',
        width: '100%',
    }
})